import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Layout from "./pages/layout";
import Home from "./pages/home";
import Gallery from "./pages/gallery";
import Courses2023 from "./pages/courses2023";
import Courses2024 from "./pages/courses2024";
import Courses2025 from "./pages/courses2025";
import Oglebay_Invitational from "./pages/Oglebay/oglebay_invitational";
import Overview from "./pages/Oglebay/overview";
import Hall_Of_Fame from "./pages/Oglebay/hall_of_fame";
import Play_Opportunities from "./pages/play_opportunities";
import Charity_Events from "./pages/charity_events";
import Results from "./pages/results";
import Add_Event from "./pages/add_event";
import Event_Details from "./pages/Oglebay/event_details";
import Past_Participants from "./pages/Oglebay/past_participants";
import Ogb_Gallery from "./pages/Oglebay/ogb_gallery";
import Reviews2023 from "./pages/reviews2023";
import Reviews2024 from "./pages/reviews2024";
import Reviews2025 from "./pages/reviews2025";
import SFXGolfLeague from "./pages/sfx_golf";
import SFX_Event from "./pages/sfx_add_event";
import Ogb2024Play from "./pages/Oglebay/Play2024";
import Ogb2025Play from "./pages/Oglebay/Play2025";
import Event_Details2024 from "./pages/Oglebay/2024event_details";
import Event_Details2025 from "./pages/Oglebay/2025event_details";
import Signup2025 from "./pages/Oglebay/2025SignupPage";
import GolfPass from "./pages/golf_pass";
import StayAndPlay from "./pages/stayPlay";
import Results_2025 from "./pages/Oglebay/2025results";
import BlufftonHome from "./pages/Bluffton/bluffton";
import BlufftonPlay from "./pages/Bluffton/blufftonplay";
import BlufftonReviews from "./pages/Bluffton/blufftonreviews";
import BlufftonCourses from "./pages/Bluffton/blufftoncourses";
import BlufftonStayPlay from "./pages/Bluffton/blufftonstayplay";
import BlufftonEdit from "./pages/Bluffton/blufftonEdit";
import Courses2026 from "./pages/courses2026";
import WestfieldHome from "./pages/Westfield/westfield";
import WestfieldPlay from "./pages/Westfield/westfieldplay";
import WestfieldReviews from "./pages/Westfield/westfieldreviews";
import WestfieldCourses from "./pages/Westfield/westfieldcourses";
import WestfieldStayPlay from "./pages/Westfield/westfieldstayplay";
import WestfieldEdit from "./pages/Westfield/westfieldedit";
import Reviews2026 from "./pages/reviews2026";
import Ogb2026Play from "./pages/Oglebay/Play2026";
import Event_Details2026 from "./pages/Oglebay/2026event_details";
import Golf_Tips from "./pages/tips_for_ready_golf";
import Signup2027 from "./pages/Oglebay/2026SignupPage";

import * as AWS from 'aws-sdk'
// import { ConfigurationOptions } from 'aws-sdk'

// const configuration: ConfigurationOptions = {
//   region: 'us-east-1',
  
// }

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="courses2023" element={<Courses2023 />} />
          <Route path="courses2024" element={<Courses2024 />} />
          <Route path="courses2025" element={<Courses2025 />} />
          <Route path="courses2026" element={<Courses2026 />} />
          <Route path="reviews2023" element={<Reviews2023 />} />
          <Route path="reviews2024" element={<Reviews2024 />} />
          <Route path="reviews2025" element={<Reviews2025 />} />
          <Route path="reviews2026" element={<Reviews2026 />} />
          <Route path="oglebay" element={<Oglebay_Invitational />} />
          <Route path='oglebay/hall_of_fame' element={<Hall_Of_Fame/>}/>
          <Route path='oglebay/overview' element={<Overview/>}/>
          <Route path='oglebay/event_details' element={<Event_Details/>}/>
          <Route path='oglebay/event_details2024' element={<Event_Details2024/>}/>
          <Route path='oglebay/event_details2025' element={<Event_Details2025/>}/>
          <Route path='oglebay/event_details2026' element={<Event_Details2026/>}/>
          <Route path='golf_tips' element={<Golf_Tips/>}/>
          <Route path='oglebay/Ogb2026signups' element={<Signup2025/>}/>
          <Route path='oglebay/Ogb2027signups' element={<Signup2027/>}/>
          <Route path='oglebay/Ogb2024Play' element={<Ogb2024Play/>}/>
          <Route path='oglebay/Ogb2025Play' element={<Ogb2025Play/>}/>
          <Route path='oglebay/Ogb2026Play' element={<Ogb2026Play/>}/>
          <Route path='oglebay/Ogb2025Results' element={<Results_2025/>}/>
          <Route path='oglebay/past_participants' element={<Past_Participants/>}/>
          <Route path='oglebay/gallery' element={<Ogb_Gallery/>}/>
          <Route path="play_opportunities" element={<Play_Opportunities />} />
          <Route path="stay&play" element={<StayAndPlay />} />
          <Route path="charity_events" element={<Charity_Events />} />
          <Route path="sfx_golf" element={<SFXGolfLeague />} />
          <Route path="golf_pass" element={<GolfPass />} />
          <Route path="sfx_setup" element={<SFX_Event />} />
          <Route path="results" element={<Results />} />
          <Route path="setup" element={<Add_Event />} />
          <Route path='bluffton' element={<BlufftonHome/>}/>
          <Route path='bluffton/play' element={<BlufftonPlay/>}/>
          <Route path='bluffton/reviews' element={<BlufftonReviews/>}/>
          <Route path='bluffton/courses' element={<BlufftonCourses/>}/>
          <Route path='bluffton/stay&play' element={<BlufftonStayPlay/>}/>
          <Route path='bluffton/setup' element={<BlufftonEdit/>}/>
          <Route path='westfield' element={<WestfieldHome/>}/>
          <Route path='westfield/play' element={<WestfieldPlay/>}/>
          <Route path='westfield/reviews' element={<WestfieldReviews/>}/>
          <Route path='westfield/courses' element={<WestfieldCourses/>}/>
          <Route path='westfield/stayplay' element={<WestfieldStayPlay/>}/>
          <Route path='westfield/setup' element={<WestfieldEdit/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { Nav, NavLink, NavMenu } from './NavbarElements';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
